export default __webpack_public_path__ + "static/media/jugs.61dbe445.png";